// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 852) return "static/chunks/852-9e4057fd14ffdfb8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "86412abb6e7b99cc" + ".js";
};